import { TokenResponse } from "types/TokenResponse";
import { ActionType, getType } from "typesafe-actions";
import * as oidcActions from "./oidcActions";

export interface OidcState {
  loading?: boolean;
  data?: TokenResponse;
  error?: string;
}

export type OidcActions = ActionType<typeof oidcActions>;

const initialState: OidcState = {};

export default function oidc(state: OidcState = initialState, action: OidcActions) {
  switch (action.type) {
    case getType(oidcActions.load):
      return { ...state, loading: true };
    case getType(oidcActions.loadSuccess):
      return { ...state, loading: false, data: action.data, error: undefined };
    case getType(oidcActions.loadFail):
      return { ...state, loading: false, error: action.error };
    case getType(oidcActions.empty):
      return initialState;
    default:
      return state;
  }
}
